import type { ReactNode } from 'react';
import cn from 'clsx';

import styles from './Grid.module.css';

type GridProps = {
  className?: string;
  children: ReactNode;
};

export const Grid = ({ className, children }: GridProps) => {
  return <div className={cn(styles.grid, className)}>{children}</div>;
};
